var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { v2 } from '@ovh-ux/manager-core-api';
export class LocationPlugin {
    constructor() {
        this.locations = null;
    }
    getLocations() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.locations === null) {
                const { data } = yield v2.get('/location');
                this.locations = data;
            }
            return this.locations;
        });
    }
}
//# sourceMappingURL=index.js.map